<template>
  <div>
    <slot />

    <silentbox-single
      ref="silent"
      :src="url"
    >
      <slot
        v-if="mediaLoaded"
        name="ctaBannerTop"
      />

      <XLazyMedia
        :media="thumbnail"
        @mediaLoaded="emitMediaLoaded"
      />

      <slot
        v-if="mediaLoaded"
        name="ctaBannerBottom"
      />
    </silentbox-single>

    <slot
      v-if="mediaLoaded"
      name="footer"
    />
  </div>
</template>

<script>
import Mixin from './mixin'

export default {
  mixins: [Mixin],

  props: {
    url: {
      type: String,
      default: ''
    }
  }
}
</script>

<style>
.silentbox-single {
  text-decoration: none !important;
}
</style>
